module.exports = __webpack_public_path__ + "img/thumbnail_Coyote_f_albino.fb40cae0.png";